import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const resetSearchStore = action('RESET_SEARCH_STORE', (scenarioId: SearchScenarioId) => ({
    scenarioId,
}));

export default resetSearchStore;
